/** Сегменты страницы матча: `/steps/:stageId/matches/:gameId/<tab>`. */
export enum StageMatchTab {
  RESULT = 'result',
  MOMENTS = 'moments',
}
